import Button from "./Button.js";
import card from "./components/card/index.js";
import card_group from "./components/card-group/index.js";
import Group from "./Group.js";
import "./index.css";
import InnerRadio from "./InnerRadio.js";
const Radio = InnerRadio;
Radio.Group = Group;
Radio.Button = Button;
Radio.Card = card;
Radio.CardGroup = card_group;
const components_radio = Radio;
export { components_radio as default };
